// Colorblind-safe categorical palette for interaction chemistry edges,
// distinct from CHAIN_COLORS (chainColors.js) since these encode a
// different channel (edge chemistry, not node/chain identity). Slots
// pulled from the project `dataviz` skill's reference palette and
// re-validated for this specific 5-color, 5-name set via its
// scripts/validate_palette.js: adjacent-pairs ALL PASS (worst normal-vision
// deltaE 29.0); all-pairs worst CVD deltaE is 7.2 (red vs green, within the
// 6-8 "legal with secondary encoding" floor) -- the always-visible text
// legend and hover tooltip label serve as that secondary encoding, per the
// skill's own allowance.
//
// Order matches backend INTERACTION_RULES (backend/data/interactions.csv);
// REPULSIVE is included for completeness even though it's rare in practice.
export const INTERACTION_TYPE_ORDER = ["H_BOND", "SALT_BRIDGE", "ARM_STACK", "HYDROPHOBIC", "REPULSIVE"];

export const INTERACTION_TYPE_COLORS = {
  H_BOND: "#eda100",
  SALT_BRIDGE: "#008300",
  ARM_STACK: "#4a3aa7",
  HYDROPHOBIC: "#2a78d6",
  REPULSIVE: "#e34948"
};

export const INTERACTION_TYPE_LABELS = {
  H_BOND: "Hydrogen bond",
  SALT_BRIDGE: "Salt bridge",
  ARM_STACK: "Aromatic stacking",
  HYDROPHOBIC: "Hydrophobic",
  REPULSIVE: "Repulsive"
};

export const UNCLASSIFIED_EDGE_COLOR = "#9aa5b5";

// An edge can carry more than one simultaneous interaction type (the
// backend bitmask-combines them); render by the single most scientifically
// notable type present, in INTERACTION_TYPE_ORDER priority.
export const getInteractionColor = (types) => {
  const list = Array.isArray(types) ? types : [];
  const primary = INTERACTION_TYPE_ORDER.find(type => list.includes(type));
  return primary ? INTERACTION_TYPE_COLORS[primary] : UNCLASSIFIED_EDGE_COLOR;
};
